var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "146A1E56-E30E-4930-8CDA-77344AA39DA8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V1-hp-Copy",
    transform: "translate(-281.000000, -20.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(281.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3252879,20 C17.8827106,20.0025325 17.4573247,19.8286753 17.143097,19.5168051 L8.81780912,11.1863397 C8.395453,10.7637209 8.23050416,10.1477406 8.38509723,9.57043263 C8.5396903,8.99312463 8.99033891,8.54219575 9.56728811,8.38750654 C10.1442373,8.23281733 10.7598348,8.39786875 11.1821909,8.82048754 L19.5074788,17.1509529 C19.8226952,17.4637896 20,17.8896361 20,18.333879 C20,18.778122 19.8226952,19.2039685 19.5074788,19.5168051 C19.193251,19.8286753 18.7678652,20.0025325 18.3252879,20 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.67471212,20 C1.23213485,20.0025325 0.80674896,19.8286753 0.492521241,19.5168051 C0.177304777,19.2039685 0,18.778122 0,18.333879 C0,17.8896361 0.177304777,17.4637896 0.492521241,17.1509529 L8.81780912,8.82048754 C9.47071512,8.16717554 10.5292849,8.16717557 11.1821908,8.82048759 C11.8350968,9.47379961 11.8350968,10.5330277 11.1821909,11.1863397 L2.856903,19.5168051 C2.54267528,19.8286753 2.11728939,20.0025325 1.67471212,20 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,11.6695346 C9.55742273,11.6720671 9.13203684,11.4982099 8.81780912,11.1863397 C8.50259266,10.8735031 8.32528788,10.4476566 8.32528788,10.0034136 C8.32528788,9.55917067 8.50259266,9.13332417 8.81780912,8.82048754 L17.143097,0.490022132 C17.5654531,0.0674033453 18.1810506,-0.097648079 18.7579998,0.057041133 C19.334949,0.211730345 19.7855976,0.662659222 19.9401907,1.23996722 C20.0947837,1.81727522 19.9298349,2.43325552 19.5074788,2.85587431 L11.1821909,11.1863397 C10.8679632,11.4982099 10.4425773,11.6720671 10,11.6695346 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,11.6695346 C9.55742273,11.6720671 9.13203684,11.4982099 8.81780912,11.1863397 L0.492521241,2.85587431 C-0.160384709,2.20256226 -0.160384688,1.1433342 0.492521288,0.490022179 C1.14542726,-0.163289842 2.203997,-0.163289863 2.856903,0.490022132 L11.1821909,8.82048754 C11.4974073,9.13332417 11.6747121,9.55917067 11.6747121,10.0034136 C11.6747121,10.4476566 11.4974073,10.8735031 11.1821909,11.1863397 C10.8679632,11.4982099 10.4425773,11.6720671 10,11.6695346 L10,11.6695346 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close-white.569c6f80d3ed25895454bf6010979014.svg";
export { ForwardRef as ReactComponent };